
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Simula la subida con un delay
export const uploadMovie = createAsyncThunk(
  "upload/uploadMovie",
  async (file, { rejectWithValue }) => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulación de espera
      return { fileName: file.name }; // Simula la respuesta del backend
    } catch (error) {
      return rejectWithValue("Error al subir la película");
    }
  }
);

const uploadSlice = createSlice({
  name: "upload",
  initialState: {
    file: null,
    uploading: false,
    progress: 0,
    message: "",
  },
  reducers: {
    setFile: (state, action) => {
      state.file = action.payload;
      state.progress = 0;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadMovie.pending, (state) => {
        state.uploading = true;
        state.progress = 0;
        state.message = "Subiendo...";
      })
      .addCase(uploadMovie.fulfilled, (state, action) => {
        state.uploading = false;
        state.progress = 100;
        state.message = `✅ ${action.payload.fileName} subido con éxito (simulado)`;
      })
      .addCase(uploadMovie.rejected, (state, action) => {
        state.uploading = false;
        state.message = action.payload;
      });
  },
});

export const { setFile } = uploadSlice.actions;
export default uploadSlice.reducer;
